import React from 'react';
import {Type} from '@spotify-internal/encore-web';

import {TranslationProps} from 'etc/types';
import withTranslation from 'lib/shared/i18n/withTranslation';

interface ErrorMessageProps extends TranslationProps {
  title?: string;
  children?: React.ReactNode;
}

const ErrorMessage = ({title, children, t}: ErrorMessageProps) => (
  <div>
    <Type.h1 variant="heading1">{title || t('subtitle_500')}</Type.h1>
    {children || <Type.p variant="body1">{t('message_500')}</Type.p>}
  </div>
);

export default withTranslation()(ErrorMessage);
